import { render } from "./StudentSessions.vue?vue&type=template&id=41a3ef8e&scoped=true"
import script from "./StudentSessions.vue?vue&type=script&lang=js"
export * from "./StudentSessions.vue?vue&type=script&lang=js"

import "./StudentSessions.vue?vue&type=style&index=0&id=41a3ef8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a3ef8e"]])

export default __exports__